import React, {useState} from 'react';
import {motion} from 'framer-motion';
import axios from 'axios';

import './uploadFilePhotoProduct.css'
import URL from '../../config/config-server-api'
import LoadingSendReceiveData from '../../utils/loadingSendReceiveData/loadingSendReceiveData';

const UploadFilePhotoProduct =({showModalUpload, idProduct, nameImage, UpdataEdited})=>{


    const [srcFileImage, setsrcFileImage]=useState('')
    const [imageFile, setImageFile] = useState('');
    const [alert, setAlert] = useState(false);
    const [loadingUploadFile, setLoadingUplodFile] = useState(false);

    const handleFileImage =async(e)=>{
        const file = await  e?.target?.files[0];
        setImageFile(file);

        if(file && idProduct){
            console.log(file)
            
            
            let reader = new FileReader();
            reader.onload=()=>{
                if(reader.readyState === 2){
                    setsrcFileImage(
                        reader.result
                    )

                }
            }
            reader.readAsDataURL(file)
        }
    }
    
    const sendFileImage=async()=>{
        const url = `${URL.UrlUpladFileForNameImage}${nameImage}/idproducto=${idProduct}`;
        console.log(url)

        var formtData = new FormData();
        await formtData.append('image',imageFile);

        const params = await{
            method:'PATCH',
            url:url,
            headers:{
                'Content-Type':'application/json'
            },
            data:formtData
        }

        console.log(params)

        if(imageFile!='' & idProduct!=''){

            console.log('send data Image');
            setLoadingUplodFile(true);
            axios(params)
            .then(res=>{
                console.log(res)
                if(res.status===200){
                    setLoadingUplodFile(false);
                    UpdataEdited({DataProduct:res.data.dataTienda})
                    setTimeout(()=>{
                        showModalUpload();
                    },1000)
                }
            })
            .then(err=>{
                console.log(err)
            })
        }else{
            console.log('else---')
            setAlert(true);
            showAlert();
        }
    }

    const showAlert =()=>{
        setTimeout(()=>{
            setAlert(false)
        },5000)
    }

    return (
        <motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{duration:0.2}} id="modal-uploasd-file" className="grid p-3 grid-cols-1 justify-items-center">
            <motion.div initial={{opacity:0,x:100}} animate={{opacity:1, x:0}} className="bg-white my-auto w-full p-2 sm:px-2 sm:w-3/4 md:w-1/2 h-auto rounded-lg">
            <div className="text-black font-bold flex flex-row-reverse cursor-pointer"><span onClick={()=>showModalUpload()}>X</span></div>
            <div className="mt-3 mx-1 md:mx-4">
                    <div>Imagen o foto del producto o servicio.</div>
                    <div style={{backgroundImage:`url(${srcFileImage})`}} className=" flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                            <div className="space-y-1 text-center">
                            <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <div className="flex text-sm text-gray-600">
                                <label htmlFor="file-upload" className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                    <span className="mr-0">Seleccione una imagen</span>
                                    <input onChange={(e)=>handleFileImage(e)} id="file-upload" name="file-upload" type="file" accept="image/*" className="sr-only"/>
                                </label>
                                {/* <p className="pl-1">o arrastrar y soltar</p> */}
                            </div>
                            <p className="text-xs text-gray-500">
                                PNG, JPG, GIF. tamaño maximo 5MB
                            </p>
                            </div>
                        </div>
                        {srcFileImage?<img src={srcFileImage} id="preview" alt="" width="100" height="100" />:''}

                        {
                            alert?
                            <motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{duration:0.5}} className="bg-red-200 text-red-500 py-1 my-2 rounded-sm px-2">
                                Seleccione una imagen.
                            </motion.div>
                            :
                            ''
                        }
                        <div className="grid justify-items-center py-3 pb-5 ">
                            <button onClick={sendFileImage} className="bg-green-600 hover:bg-green-500 focus:outline-none text-white font-bold px-10 rounded-xl" >Guardar</button>
                        </div>
            </div>
            {
                loadingUploadFile?
                <LoadingSendReceiveData/>
                :
                ''
            }
            </motion.div>
        </motion.div>
    );
}


export default UploadFilePhotoProduct;